module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ey8sh"))).then(() => parcelRequire('ljYL6'));